"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Authorization = exports.Token = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
var Buffer = require('buffer/').Buffer;
var __1 = require("..");
var Token = /** @class */ (function () {
    function Token(_a) {
        var id = _a.id, issuer = _a.issuer, subject = _a.subject, audience = _a.audience, issued = _a.issued, notBefore = _a.notBefore, notAfter = _a.notAfter, scope = _a.scope, state = _a.state, active = _a.active;
        this.id = id;
        this.issuer = issuer;
        this.subject = subject;
        this.audience = audience;
        this.issued = issued;
        this.notBefore = notBefore;
        this.notAfter = notAfter;
        this.scope = scope;
        this.state = state;
        this.active = active;
    }
    return Token;
}());
exports.Token = Token;
var Authorization = /** @class */ (function () {
    function Authorization(_a) {
        var address = _a.address;
        this.address = address;
    }
    Authorization.prototype.issueToken = function (_a) {
        var id = _a.id, subject = _a.subject, issuer = _a.issuer, _b = _a.audience, audience = _b === void 0 ? '' : _b, _c = _a.notBefore, notBefore = _c === void 0 ? new Date() : _c, _d = _a.validity, validity = _d === void 0 ? 3600 : _d, _e = _a.scope, scope = _e === void 0 ? '' : _e, _f = _a.state, state = _f === void 0 ? '' : _f;
        return __awaiter(this, void 0, void 0, function () {
            var _id, _issued, _notBefore, _notAfter, nonce, token, box, accessToken;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        _id = id || __1.Utilities.uniqueId();
                        _issued = new Date().getTime();
                        _notBefore = notBefore ? notBefore.getTime() : _issued;
                        _notAfter = validity === -1
                            ? new Date('9999-12-31T23:59:59.999Z').getTime()
                            : new Date(_notBefore + validity * 1000).getTime();
                        return [4 /*yield*/, __1.Address.nonce()];
                    case 1:
                        nonce = _g.sent();
                        token = new Token({
                            id: _id,
                            issuer: issuer,
                            subject: subject,
                            audience: audience,
                            issued: _issued,
                            notBefore: _notBefore,
                            notAfter: _notAfter,
                            scope: scope,
                            state: state,
                        });
                        return [4 /*yield*/, this.address.secretBoxEncrypt({
                                nonce: nonce,
                                message: new Uint8Array(Buffer.from(JSON.stringify(token))),
                            })];
                    case 2:
                        box = _g.sent();
                        accessToken = ''.concat(token.id + ".", Buffer.from(nonce).toString('base64') + ".", "" + Buffer.from(box).toString('base64'));
                        return [2 /*return*/, accessToken];
                }
            });
        });
    };
    Authorization.prototype.inspectToken = function (accessToken) {
        return __awaiter(this, void 0, void 0, function () {
            var nonce, box, parts, message, token, currentTime, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!accessToken) {
                            throw new Error('Invalid token');
                        }
                        parts = accessToken.split('.');
                        if (!(parts[0] &&
                            parts[0] !== '' &&
                            parts[1] &&
                            parts[1] !== '' &&
                            parts[2] &&
                            parts[2] !== '')) return [3 /*break*/, 5];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        nonce = new Uint8Array(Buffer.from(parts[1], 'base64'));
                        box = new Uint8Array(Buffer.from(parts[2], 'base64'));
                        return [4 /*yield*/, this.address.secretBoxDecrypt({
                                nonce: nonce,
                                box: box,
                            })];
                    case 2:
                        message = _a.sent();
                        token = new Token(JSON.parse(Buffer.from(message).toString('utf-8')));
                        currentTime = new Date().getTime();
                        if (token.notBefore <= currentTime && currentTime <= token.notAfter) {
                            token.active = true;
                        }
                        else {
                            token = new Token({
                                active: false,
                            });
                        }
                        return [2 /*return*/, token];
                    case 3:
                        error_1 = _a.sent();
                        throw new Error('Invalid token');
                    case 4: return [3 /*break*/, 6];
                    case 5: throw new Error('Invalid token');
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    return Authorization;
}());
exports.Authorization = Authorization;
